import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_CHIESE } from '../queries/chiese';

export const fetchChiese = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: { where },
      query: FETCH_CHIESE,
    });

    return result.data.chieses.edges.map((edge) => edge.node);
  } catch (error) {
    console.error('[fetchChiese] Error:', error);
    return [];
  }
};
